;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('deskfyLoader', deskfyLoader)

  /* @ngInject */
  function deskfyLoader () {
    return {
      restrict: 'EA',
      scope: {
        shouldShowLoader: '='
      },
      templateUrl: '/core/directives/deskfy-loader/deskfy-loader-directive.html?$$REVISION$$',
      controller: 'DeskfyLoaderController'
    }
  }
})()
